import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import useStyles from './styles';
import usePreviewPublisher from '../../hooks/usePreviewPublisher';
import AudioSettings from '../AudioSetting';
import FormControl from '@material-ui/core/FormControl';
import VideoSettings from '../VideoSetting';
import { RoomContext } from '../../context/RoomContext';
import { UserContext } from '../../context/UserContext';
import LinearProgress from '@material-ui/core/LinearProgress';
import {useLocation} from "react-router-dom";
import jwt_decode from "jwt-decode";

export default function WaitingRoom({ location }) {
  const classes = useStyles();
  const { push } = useHistory();
  const { user, setUser } = useContext(UserContext);
  const { credentials, setCredentials } = useContext(RoomContext);
  const waitingRoomVideoContainer = useRef();
  const roomToJoin = location?.state?.room || '';
  const [apikey, setApikey] = useState('45197012');
  const [sessionId, setSessionId] = useState('');
  const [token, setToken] = useState('');
  const [userName, setUserName] = useState('');
  const [isRoomNameInvalid, setIsRoomNameInvalid] = useState(false);
  const [isUserNameInvalid, setIsUserNameInvalid] = useState(false);
  const [localAudio, setLocalAudio] = useState(
    user.defaultSettings.publishAudio
  );
  const [localVideo, setLocalVideo] = useState(
    user.defaultSettings.publishVideo
  );
  const [localVideoSource, setLocalVideoSource] = useState(undefined);
  const [localAudioSource, setLocalAudioSource] = useState(undefined);
  /* const [devices, setDevices] = useState(null); */
  let [audioDevice, setAudioDevice] = useState('');
  let [videoDevice, setVideoDevice] = useState('');
  // var decoded = jwt.decode(token);
  const search = useLocation().search;
  const apiInfo = new URLSearchParams(search).get('jwtToken');
  let ischecked = false;
  let videoApiData = null;
  const {
    createPreview,
    destroyPreview,
    previewPublisher,
    logLevel,
    previewMediaCreated,
    deviceInfo,
    accessAllowed
  } = usePreviewPublisher();

  const handleVideoSource = React.useCallback(
    (e) => {
      const videoDeviceId = e.target.value;
      setVideoDevice(e.target.value);
      previewPublisher.setVideoDevice(videoDeviceId);
      setLocalVideoSource(videoDeviceId);
    },
    [previewPublisher, setVideoDevice, setLocalVideoSource]
  );

  const handleAudioSource = React.useCallback(
    (e) => {
      const audioDeviceId = e.target.value;
      setAudioDevice(audioDeviceId);
      previewPublisher.setAudioDevice(audioDeviceId);
      setLocalAudioSource(audioDeviceId);
    },
    [previewPublisher, setAudioDevice, setLocalAudioSource]
  );

  const redirectHttps = React.useCallback(() => {
    const url = window.location.href;
    if (
      url.toString().indexOf('http://') === 0 &&
      url.toString().indexOf('http://localhost') !== 0
    ) {
      window.location.href = window.location.href
        .toString()
        .replace('http://', 'https://');
    } else {
      return;
    }
  }, []);

  const handleJoinClick = () => {
    if (validateForm()) {
      localStorage.setItem('username', userName);
      push(`room/${sessionId}`);
    }
  };

  const validateForm = () => {
    if (userName === '') {
      setIsUserNameInvalid(true);
      return false;
    }
    return true;
  };

  const onChangeApiKey = (e) => {
    const apikey = e.target.value;
    if (apikey === '' || apikey.trim() === '') {
      // Space detected
      setApikey('');
      return;
    }
    setApikey(apikey);
  };

  const onChangeSessionId = (e) => {
    const sessionId = e.target.value;
    if (sessionId === '' || sessionId.trim() === '') {
      // Space detected
      setSessionId('');
      return;
    }
    setSessionId(sessionId);
  };

  const onChangeToken = (e) => {
    const token = e.target.value;
    if (token === '' || token.trim() === '') {
      // Space detected
      setToken('');
      return;
    }
    setToken(token);
  };

  const onChangeParticipantName = (e) => {
    const userName = e.target.value;
    if (userName === '' || userName.trim() === '') {
      // Space detected
      setUserName('');
      return;
    }
    setIsUserNameInvalid(false);
    setUserName(userName);
  };

  const onKeyDown = (e) => {
    if (e.keyCode === 13) {
      handleJoinClick();
    }
  };

  const handleAudioChange = React.useCallback((e) => {
    setLocalAudio(e.target.checked);
  }, []);

  const handleVideoChange = React.useCallback((e) => {
    setLocalVideo(e.target.checked);
  }, []);

  useEffect(() => {


    if(apiInfo){
        //alert(apiInfo);
        console.log(apiInfo);
        var decoded = jwt_decode(apiInfo);
        videoApiData = decoded;

        console.log('apiKey: ' + videoApiData.apikey)
        console.log('session: ' + videoApiData.session)
        console.log('token: ' + videoApiData.token)
         setApikey(videoApiData.apikey);
         setSessionId(videoApiData.session);
         setToken(videoApiData.token);
        
        // var decoded = jwt.decode(apiInfo, {complete: true});
        // console.log(jwt.decode(apiInfo, {complete: true}));
      }else{
        //alert('No Token: ' + ischecked);
      }



    });



    useEffect(() => {
    redirectHttps();
    if (localStorage.getItem('username')) {
      setUserName(localStorage.getItem('username'));
    }
  }, []);

  useEffect(() => {
    if (
      localAudio !== user.defaultSettings.publishAudio ||
      localVideo !== user.defaultSettings.publishVideo ||
      localAudioSource !== user.defaultSettings.audioSource ||
      localVideoSource !== user.defaultSettings.videoSource
    ) {
      setUser({
        ...user,
        defaultSettings: {
          publishAudio: localAudio,
          publishVideo: localVideo,
          audioSource: localAudioSource,
          videoSource: localVideoSource
        }
      });
    }
  }, [
    localAudio,
    localVideo,
    user,
    setUser,
    localAudioSource,
    localVideoSource
  ]);

  useEffect(() => {
    if (
      apikey !== credentials.apikey ||
      sessionId !== credentials.sessionId ||
      token !== credentials.token
    ) {
      setCredentials({
        apikey,
        sessionId,
        token
      });
    }
  }, [
    apikey,
    sessionId,
    token,
    credentials.apikey,
    credentials.sessionId,
    credentials.token,
    setCredentials
  ]);

  useEffect(() => {
    if (userName !== user.userName) {
      setUser({ ...user, userName: userName });
    }
  }, [userName, user, setUser]);

  useEffect(() => {
    if (previewPublisher && previewMediaCreated && deviceInfo) {
      previewPublisher.getAudioDevice().then((currentAudioDevice) => {
        setAudioDevice(currentAudioDevice.deviceId);
      });
      const currentVideoDevice = previewPublisher.getVideoDevice();
      setVideoDevice(currentVideoDevice.deviceId);
    }
  }, [
    deviceInfo,
    previewPublisher,
    setAudioDevice,
    setVideoDevice,
    previewMediaCreated
  ]);

  useEffect(() => {
    if (previewPublisher) {
      if (localAudio && !previewPublisher.isAudioEnabled()) {
        previewPublisher.enableAudio();
      } else if (!localAudio && previewPublisher.isAudioEnabled()) {
        previewPublisher.disableAudio();
      }
    }
  }, [localAudio, previewPublisher]);

  useEffect(() => {
    if (previewPublisher) {
      if (localVideo && !previewPublisher.isVideoEnabled()) {
        previewPublisher.enableVideo();
      } else if (!localVideo && previewPublisher.isVideoEnabled()) {
        previewPublisher.disableVideo();
      }
    }
  }, [localVideo, previewPublisher]);

  useEffect(() => {
    if (waitingRoomVideoContainer.current) {
      createPreview(waitingRoomVideoContainer.current);
    }

    return () => {
      destroyPreview();
    };
  }, [createPreview, destroyPreview]);

  return (
    <div className={classes.waitingRoomContainer}>
      <div className={classes.memdTitleLarge}>Your visit is about to begin.</div>
      <div className={classes.copy}>To ensure you have a good experience, please check your settings.</div>
      <div className={classes.copy}>*Required fields</div>
      <form className={classes.form} noValidate>
        <label className={classes.label}>First name</label>
        <input
          autoComplete="Name"
          className={classes.input}
          id="publisher-name"
          name="name"
          onChange={onChangeParticipantName}
          onKeyDown={onKeyDown}
          placeholder={userName === '' ? 'First name' : ''}
          required
          type="text"
          value={userName}
        />
        { isUserNameInvalid && (
          <div className={classes.error}>First name is required.</div>
        )}
        { deviceInfo && previewMediaCreated && (
          <FormControl className={classes.inputGroup}>
            <label className={classes.label} id="demo-simple-select-label">Select Audio Source</label>
            <select
              className={classes.input}
              id="demo-simple-select"
              name="demo-simple-select-label"
              onChange={handleAudioSource}
              value={audioDevice}
            >
              { deviceInfo.audioInputDevices.map((device) => (
                <option key={device.deviceId} value={device.deviceId}>
                  {device.label}
                </option>
              ))}
            </select>
            { deviceInfo.videoInputDevices && (
              <>
                <label className={classes.label} id="video">Select Video Source</label>
                <select
                  className={classes.input}
                  id="demo-simple-select"
                  name="video"
                  onChange={handleVideoSource}
                  value={videoDevice}
                  >
                  { deviceInfo.videoInputDevices.map((device) => (
                    <option key={device.deviceId} value={device.deviceId}>
                      {device.label}
                    </option>
                  ))}
                </select>
              </>
            )}
          </FormControl>
        )}
      </form>
      <div
        className={classes.waitingRoomVideoPreview}
        id="waiting-room-video-container"
        ref={waitingRoomVideoContainer}
      ></div>
      { localAudio && <LinearProgress color="primary" value={logLevel} variant="determinate" />}
      <AudioSettings
        hasAudio={localAudio}
        onAudioChange={handleAudioChange}
      />
      <VideoSettings
        hasVideo={localVideo}
        onVideoChange={handleVideoChange}
      />
      <button
        className={classes.primaryButton}
        disabled={ !sessionId || !token || !userName }
        onClick={handleJoinClick}
      >
        Join call
      </button>
    </div>
  );
}
